import React, { Fragment, useEffect, useState } from "react";
import { get, update } from "../../../constants/apiRoutes";
import Swal from "sweetalert2";
import "../../../index.css";
import Upstream from "../SupportComponents/Upstream";

const Configuration = () => {
  const [loading, setLoading] = useState(true);
  const [formValues, setFormValues] = useState({
    ticker: "",
    convRateUSD: "",
    convFactOZ: "",
    markupType: "",
    markupRate14Karat_GE: 0,
    markupRate14Karat_LT: 0,
    markupRate14Karat_M: 0,
    markupRate18Karat_LT: 0,
    markupRate18Karat_M: 0,
    markupRate18Karat_GE: 0,
    markupRate21Karat_LT: 0,
    markupRate21Karat_M: 0,
    markupRate21Karat_GE: 0,
    markupRate22Karat_LT: 0,
    markupRate22Karat_M: 0,
    markupRate22Karat_GE: 0,
    markupRate24Karat_LT: 0,
    markupRate24Karat_M: 0,
    markupRate24Karat_GE: 0,
    threshold1: 0,
    threshold2: 0,
    threshold3: 0,
    streamTimes: ["", "", ""],
    significantValueChange: "",
    timerIntervalMinutes: "",
    broadcast_currency: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const result = await get("AppSettings/all_settings");

      setFormValues((prevValues) => ({
        ...prevValues,
        markupType: result.markupType.toString(),
        ticker: result.ticker,
        convRateUSD: result.convRateUSD,
        convFactOZ: result.convFactOZ,
        markupRate14Karat_GE: result.markupRate14Karat_GE,
        markupRate14Karat_LT: result.markupRate14Karat_LT,
        markupRate14Karat_M: result.markupRate14Karat_M,
        markupRate18Karat_LT: result.markupRate18Karat_LT,
        markupRate18Karat_M: result.markupRate18Karat_M,
        markupRate18Karat_GE: result.markupRate18Karat_GE,
        markupRate21Karat_LT: result.markupRate21Karat_LT,
        markupRate21Karat_M: result.markupRate21Karat_M,
        markupRate21Karat_GE: result.markupRate21Karat_GE,
        markupRate22Karat_LT: result.markupRate22Karat_LT,
        markupRate22Karat_M: result.markupRate22Karat_M,
        markupRate22Karat_GE: result.markupRate22Karat_GE,
        markupRate24Karat_LT: result.markupRate24Karat_LT,
        markupRate24Karat_M: result.markupRate24Karat_M,
        markupRate24Karat_GE: result.markupRate24Karat_GE,
        threshold1: result.threshold1,
        threshold2: result.threshold2,
        threshold3: result.threshold3,
        streamTimes: [
          result.streamTimes[0],
          result.streamTimes[1],
          result.streamTimes[2],
        ],
        significantValueChange: result.significantValueChange,
        timerIntervalMinutes: result.timerIntervalMinutes,
        broadcast_currency: result.broadcast_currency,
      }));
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    try {
      let updatedData0 = {
        id: 1,
        ticker: formValues.ticker,
        convRateUSD: formValues.convRateUSD,
        convFactOZ: formValues.convFactOZ,
      };
       await update(`AppSettings/settings_0`, updatedData0);

      let updatedData1 = {
        id: 0,
        markupRate14Karat_GE: formValues.markupRate14Karat_GE,
        markupRate14Karat_LT: formValues.markupRate14Karat_LT,
        markupRate14Karat_M: formValues.markupRate14Karat_M,
        markupRate18Karat_LT: formValues.markupRate18Karat_LT,
        markupRate18Karat_M: formValues.markupRate18Karat_M,
        markupRate18Karat_GE: formValues.markupRate18Karat_GE,
        markupRate21Karat_LT: formValues.markupRate21Karat_LT,
        markupRate21Karat_M: formValues.markupRate21Karat_M,
        markupRate21Karat_GE: formValues.markupRate21Karat_GE,
        markupRate22Karat_LT: formValues.markupRate22Karat_LT,
        markupRate22Karat_M: formValues.markupRate22Karat_M,
        markupRate22Karat_GE: formValues.markupRate22Karat_GE,
        markupRate24Karat_LT: formValues.markupRate24Karat_LT,
        markupRate24Karat_M: formValues.markupRate24Karat_M,
        markupRate24Karat_GE: formValues.markupRate24Karat_GE,
        markupType: formValues.markupType,
        threshold1: formValues.threshold1,
        threshold2: formValues.threshold2,
        threshold3: formValues.threshold3,
      };
       await update(`AppSettings/settings_1`, updatedData1);

      let updatedData2 = {
        id: 1,
        streamTimes: [
          formValues.streamTimes[0],
          formValues.streamTimes[1],
          formValues.streamTimes[2],
        ],

        significantValueChange: formValues.significantValueChange,
        timerIntervalMinutes: formValues.timerIntervalMinutes,
        broadcast_currency: formValues.broadcast_currency,
      };
       await update(`AppSettings/settings_2`, updatedData2);

      Swal.fire({
        icon: "success",
        title: "Configurations Updated Successfully",
        showConfirmButton: true,
        timer: 2500,
      });

      fetchData();
    } catch (error) {
      console.error("Failed to update data:", error);
    }
  };

  const handleCancel = () => {
    setFormValues({
      ticker: "",
      convRateUSD: "",
      convFactOZ: "",
      markupType: "",
      markupRate14Karat_GE: 0,
      markupRate14Karat_LT: 0,
      markupRate14Karat_M: 0,
      markupRate18Karat_LT: 0,
      markupRate18Karat_M: 0,
      markupRate18Karat_GE: 0,
      markupRate21Karat_LT: 0,
      markupRate21Karat_M: 0,
      markupRate21Karat_GE: 0,
      markupRate22Karat_LT: 0,
      markupRate22Karat_M: 0,
      markupRate22Karat_GE: 0,
      markupRate24Karat_LT: 0,
      markupRate24Karat_M: 0,
      markupRate24Karat_GE: 0,
      threshold1: 0,
      threshold2: 0,
      threshold3: 0,
      streamTimes: ["", "", ""],
      significantValueChange: "",
      timerIntervalMinutes: "",
      broadcast_currency: "",
    });
  };

  return (
    <Fragment>
      <section className=" my-10 mx-20">
        <Upstream />
      </section>

      {loading ? (
        <p className="text-center m-4 text-2xl text-gray-400">Loading....</p>
      ) : (
        <section className=" my-10 mx-20">
          <h2 className="text-2xl font-bold mb-4">
            Update Configuration Settings
          </h2>
          <div>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleUpdate();
              }}
              className="p-2 rounded-xl border-2 border-gray-200 bg-white"
            >
              <div className="flex flex-row ">
                <div className="p-4 rounded-xl border-2 w-1/2 m-4 border-gray-200 bg-white">
                  <div className=" flex flex-row gap-4 w-full">
                    <h1 className="text-sm font-bold text-gray-700 w-1/2 mb-4 p-2 rounded-lg">
                      Broadcast Currency
                    </h1>
                    <h1 className="text-sm font-bold text-gray-700 w-1/2 mb-4 p-2 rounded-lg">
                      USD to AED Conversion Rate
                    </h1>
                  </div>
                  <div className="mb-6 flex flex-row gap-4 w-full">
                    <label className="input border-none outline-none flex items-center h-9 gap-4 w-1/2 bg-gray-200">
                      <input
                        type="text"
                        name="broadcast_currency"
                        required
                        value={formValues.broadcast_currency}
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            broadcast_currency: e.target.value,
                          })
                        }
                        className="grow"
                        placeholder="Currency Code"
                      />
                    </label>

                    <label className="input bg-gray-200 flex h-9 items-center gap-4 w-1/2">
                      <input
                        type="number"
                        name="convRateUSD"
                        min={0}
                        step="any"
                        required
                        value={formValues.convRateUSD}
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            convRateUSD: e.target.value,
                          })
                        }
                        className="grow text-end"
                        placeholder="Currency"
                      />
                    </label>
                  </div>
                </div>

                <div className="p-4 rounded-xl border-2 w-1/2 border-gray-200 m-4 bg-white">
                  <div className="flex flex-row gap-4 w-full">
                    <h1 className="text-sm font-bold text-gray-700 w-1/2 mb-4 p-2 rounded-lg">
                      Streaming Currency
                    </h1>
                    <h1 className="text-sm font-bold text-gray-700 w-1/2 mb-4 p-2 rounded-lg">
                      Streaming Interval In Minutes
                    </h1>
                  </div>
                  <div className="mb-6 flex flex-row gap-4 w-full">
                    <label className="input border-none outline-none flex items-center h-9 gap-4 w-1/2 bg-gray-200">
                      <input
                        type="text"
                        name="ticker"
                        value={formValues.ticker}
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            ticker: e.target.value,
                          })
                        }
                        required
                        className="grow"
                        placeholder="Streaming Currency"
                      />
                    </label>
                    <label className=" input bg-gray-200 flex h-9 items-center gap-4 w-1/2">
                      <input
                        type="number"
                        min={0}
                        name="timerIntervalMinutes"
                        value={formValues.timerIntervalMinutes}
                        required
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            timerIntervalMinutes: e.target.value,
                          })
                        }
                        className="grow text-end"
                        placeholder="Streaming Interval"
                      />
                      <span className=" mr-10 text-gray-500">Mins</span>
                    </label>
                  </div>
                </div>
              </div>

              <div className=" flex flex-row">
                <div className="p-4 rounded-xl border-2 w-1/2 m-4 border-gray-200 bg-white">
                  <h1 className="text-sm font-bold text-gray-700 w-fit mb-4 p-2 rounded-lg">
                    Markup Karatwise
                  </h1>
                  <div className="mb-6 flex flex-row gap-4 w-full bg-gray-200 p-2 rounded-lg">
                    <div className="flex flex-col">
                      <label>Threshold 1:</label>
                      <div>
                        <input
                          type="number"
                          min={0}
                          name="threshold1"
                          required
                          value={formValues.threshold1}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              threshold1: e.target.value,
                            })
                          }
                          className="rounded-lg p-2 w-full text-end border"
                          placeholder="Threshold 1"
                        />
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <label>Threshold 2:</label>
                      <div>
                        <input
                          type="number"
                          min={0}
                          name="threshold2"
                          required
                          value={formValues.threshold2}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              threshold2: e.target.value,
                            })
                          }
                          className="rounded-lg p-2 w-full text-end border"
                          placeholder="Threshold 2"
                        />
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <label>Threshold 3:</label>
                      <div>
                        <input
                          type="number"
                          min={0}
                          name="threshold3"
                          required
                          value={formValues.threshold3}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              threshold3: e.target.value,
                            })
                          }
                          className="rounded-lg p-2 w-full text-end border"
                          placeholder="Threshold 3"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-6 flex flex-row gap-4 w-full">
                    <label className="flex items-center gap-2 w-1/2 bg-gray-200 p-2 rounded-lg">
                      <input
                        type="radio"
                        name="markupTypePercentage"
                        value="0"
                        checked={formValues.markupType === "0"}
                        onChange={(e) => {
                          setFormValues({
                            ...formValues,
                            markupType: e.target.value,
                          });
                        }}
                        className="form-radio h-5 w-5 text-yellow-600"
                      />
                      <span className="text-sm text-gray-700">Percentage</span>
                    </label>
                    <label className="flex items-center gap-2 w-1/2 bg-gray-200 p-2 rounded-lg">
                      <input
                        type="radio"
                        name="markupTypeFlat"
                        value="1"
                        checked={formValues.markupType === "1"}
                        onChange={(e) => {
                          setFormValues({
                            ...formValues,
                            markupType: e.target.value,
                          });
                        }}
                        className="form-radio h-5 w-5 text-yellow-600"
                      />
                      <span className="text-sm text-gray-700">Fixed Rate</span>
                    </label>
                  </div>
                  <div className="flex flex-col gap-4">
                    <div className=" flex flex-row w-full bg-gray-200 p-4 rounded justify-between">
                      <p className="text-xs text-gray-700 flex-shrink-0 w-16">
                        Karat
                      </p>
                      <div className="flex-1 flex flex-row justify-between">
                        <p className="text-xs text-gray-700 flex-shrink-0 ">
                          Less Than {formValues.threshold1}
                        </p>
                        <p className="text-xs text-gray-700 flex-shrink-0 ">
                          Less Than {formValues.threshold2}
                        </p>
                        <p className="text-xs text-gray-700 flex-shrink-0 ">
                          Above {formValues.threshold3}
                        </p>
                      </div>
                    </div>
                    <div className=" flex flex-row gap-4 w-full">
                      <label className="flex items-center gap-4  bg-gray-200 p-2 rounded-lg">
                        <p className="text-xs text-gray-700 flex-shrink-0">
                          24 Karat:
                        </p>
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate24Karat_LT"
                          required
                          min={0}
                          value={formValues.markupRate24Karat_LT}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate24Karat_LT: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="24LT"
                        />
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate24Karat_M"
                          required
                          min={0}
                          value={formValues.markupRate24Karat_M}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate24Karat_M: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="24M"
                        />
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate24Karat_GE"
                          required
                          min={0}
                          value={formValues.markupRate24Karat_GE}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate24Karat_GE: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="24GE"
                        />
                      </label>
                    </div>
                    <div className=" flex flex-row gap-4 w-full">
                      <label className="flex items-center gap-4  bg-gray-200 p-2 rounded-lg">
                        <p className="text-xs text-gray-700 flex-shrink-0">
                          22 Karat:
                        </p>
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate22Karat_LT"
                          required
                          min={0}
                          value={formValues.markupRate22Karat_LT}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate22Karat_LT: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="22LT"
                        />
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate22Karat_M"
                          required
                          min={0}
                          value={formValues.markupRate22Karat_M}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate22Karat_M: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="22M"
                        />
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate22Karat_GE"
                          required
                          min={0}
                          value={formValues.markupRate22Karat_GE}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate22Karat_GE: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="22GE"
                        />
                      </label>
                    </div>
                    <div className=" flex flex-row gap-4 w-full">
                      <label className="flex items-center gap-4  bg-gray-200 p-2 rounded-lg">
                        <p className="text-xs text-gray-700 flex-shrink-0">
                          21 Karat:
                        </p>
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate21Karat_LT"
                          required
                          min={0}
                          value={formValues.markupRate21Karat_LT}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate21Karat_LT: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="21LT"
                        />
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate21Karat_M"
                          required
                          min={0}
                          value={formValues.markupRate21Karat_M}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate21Karat_M: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="21M"
                        />
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate21Karat_GE"
                          required
                          min={0}
                          value={formValues.markupRate21Karat_GE}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate21Karat_GE: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="21GE"
                        />
                      </label>
                    </div>
                    <div className=" flex flex-row gap-4 w-full">
                      <label className="flex items-center gap-4  bg-gray-200 p-2 rounded-lg">
                        <p className="text-xs text-gray-700 flex-shrink-0">
                          18 Karat:
                        </p>
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate18Karat_LT"
                          required
                          min={0}
                          value={formValues.markupRate18Karat_LT}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate18Karat_LT: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="18LT"
                        />
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate18Karat_M"
                          required
                          min={0}
                          value={formValues.markupRate18Karat_M}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate18Karat_M: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="18M"
                        />
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate18Karat_GE"
                          required
                          min={0}
                          value={formValues.markupRate18Karat_GE}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate18Karat_GE: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="18GE"
                        />
                      </label>
                    </div>
                    <div className=" flex flex-row gap-4 w-full">
                      <label className="flex items-center gap-4  bg-gray-200 p-2 rounded-lg">
                        <p className="text-xs text-gray-700 flex-shrink-0">
                          14 Karat:
                        </p>
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate14Karat_LT"
                          required
                          min={0}
                          value={formValues.markupRate14Karat_LT}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate14Karat_LT: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="14LT"
                        />
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate14Karat_M"
                          required
                          min={0}
                          value={formValues.markupRate14Karat_M}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate14Karat_M: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="14M"
                        />
                        <input
                          type="number"
                          step="0.1"
                          name="markupRate14Karat_GE"
                          required
                          min={0}
                          value={formValues.markupRate14Karat_GE}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              markupRate14Karat_GE: e.target.value,
                            })
                          }
                          className="focus:outline-none rounded-lg p-2 w-full text-end"
                          placeholder="14GE"
                        />
                      </label>
                    </div>
                  </div>
                </div>

                <div className="p-4 rounded-xl border-2 w-1/2 m-4 border-gray-200 bg-white">
                  <h1 className="text-sm font-bold text-gray-700 w-fit mb-4 p-2 rounded-lg">
                    Broadcast Parameter
                  </h1>

                  <div className="mb-6 flex flex-row gap-4 w-full">
                    <label className="input border-none outline-none flex items-center h-9 gap-4 w-1/2 bg-gray-200">
                      <input
                        type="time"
                        name="streamTimes0"
                        value={formValues.streamTimes[0]}
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            streamTimes0: e.target.value,
                          })
                        }
                        required
                        className="grow"
                        placeholder="Stream Time"
                      />
                    </label>
                    <label className="input bg-gray-200 flex h-9 items-center gap-4 w-1/2">
                      <input
                        type="time"
                        name="streamTimes1"
                        required
                        value={formValues.streamTimes[1]}
                        className="grow"
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            streamTimes1: e.target.value,
                          })
                        }
                        placeholder="Stream Time"
                      />
                    </label>
                  </div>
                  <div className="mb-6 flex flex-row gap-4 w-1/2">
                    <label className="input border-none outline-none flex items-center h-9 gap-4 w-full bg-gray-200">
                      <input
                        type="time"
                        name="streamTimes2"
                        required
                        className="grow"
                        value={formValues.streamTimes[2]}
                        placeholder="Stream Time"
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            streamTimes2: e.target.value,
                          })
                        }
                      />
                    </label>
                  </div>
                  <div className="mb-6 flex flex-row gap-4 w-full">
                    <label className="flex items-center gap-4 w-full bg-gray-200 p-2 rounded-lg">
                      <p className="text-sm text-gray-700 pl-3  flex-shrink-0 w-1/3">
                        Value Change Of :
                      </p>
                      <input
                        type="number"
                        name="significantValueChange"
                        required
                        min={0}
                        value={formValues.significantValueChange}
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            significantValueChange: e.target.value,
                          })
                        }
                        className="focus:outline-none rounded-lg p-2 w-full text-end"
                      />
                      <p className="text-sm text-gray-700  flex-shrink-0">
                        USD
                      </p>
                    </label>
                    {/* <label className="input border-none w-1/2 outline-none flex items-center h-9 gap-4  bg-gray-200">
                      <input
                        type="number"
                        min={0}
                        name="significantValueChange"
                        required
                        className="grow text-end"
                        value={formValues.significantValueChange}
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            significantValueChange: e.target.value,
                          })
                        }
                        placeholder="USD"
                      />
                    </label> */}
                  </div>
                </div>
              </div>

              <div className="flex w-full gap-2 justify-end mt-4">
                <button
                  type="submit"
                  className="text-xs bg-yellow-700 text-white w-24 h-9 rounded-lg"
                >
                  Update
                </button>
                <button
                  type="reset"
                  onClick={() => handleCancel()}
                  className="text-xs bg-black text-white w-24 h-9 rounded-lg"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </section>
      )}
    </Fragment>
  );
};

export default Configuration;
